/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/require-default-props */
import React, { useRef, useState } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import { Popup } from '@progress/kendo-react-popup';
export default function Select({ className, optionRenderer, valueRenderer, options, label, value, onChange }) {
    var _a;
    const [visible, setVisible] = useState(false);
    const anchor = useRef(null);
    return (React.createElement("div", { className: className ? `${className} selectContainer` : 'selectContainer' },
        React.createElement("button", { type: "button", className: "qmb-control--menu content-actions__toggle", onClick: () => setVisible(true), ref: anchor },
            label,
            ":",
            ' ',
            React.createElement("span", { className: "selectValue" }, (valueRenderer === null || valueRenderer === void 0 ? void 0 : valueRenderer(value)) || ((_a = options.find((option) => option.value === value)) === null || _a === void 0 ? void 0 : _a.label))),
        React.createElement(Popup, { anchor: anchor.current, show: visible, onClose: () => setVisible(false) },
            React.createElement(ClickAwayListener, { onClickAway: () => setVisible(false), onKeyDown: (e) => {
                    if (e.key === 'Escape') {
                        setVisible(false);
                    }
                } },
                React.createElement("div", { id: "popup_convert", className: "qmb-popup--action-list" },
                    React.createElement("ul", { role: "presentation" }, options.map((option) => (optionRenderer === null || optionRenderer === void 0 ? void 0 : optionRenderer(option)) || (React.createElement("li", { key: option.value, role: "presentation" },
                        React.createElement("button", { type: "button", onClick: () => {
                                onChange(option.value);
                                setVisible(false);
                            } }, option.label))))))))));
}
